"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RetailLocationInfo = void 0;
const React = require("react");
const react_1 = require("react");
const TSalesOrderType_1 = require("../../../types/TSalesOrderType");
const context_1 = require("../../../handlers/CustomerLocationHandler/context");
const useRequiredContext_1 = require("../../../../../../hooks/useRequiredContext");
const IconButton_1 = require("../../../../../../components/base/atoms/IconButton");
const standardSizes_1 = require("../../../../../../types/standardSizes");
const openLink_1 = require("../../../../../../helpers/openLink");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "RetailLocationInfo");
const RetailLocationInfo = ({ retailLocation, orderType }) => {
    const { phoneNumber } = retailLocation;
    const { customerLocation } = (0, useRequiredContext_1.useRequiredContext)(context_1.CustomerLocationContext);
    const latLng = (0, react_1.useMemo)(() => {
        if (!customerLocation) {
            return null;
        }
        const { lat, lng } = customerLocation;
        return {
            lat,
            lng
        };
    }, [customerLocation]);
    const directionsLink = (0, react_1.useMemo)(() => {
        if (!latLng) {
            return "";
        }
        return retailLocation.getDirectionsUrl(latLng.lat, latLng.lng);
    }, [latLng]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css("section") },
            React.createElement("header", { className: css("section_header") }, "Contact Restaurant"),
            React.createElement("p", { className: css("section_text") },
                React.createElement("a", { href: `tel:${phoneNumber}`, title: "Contact the restaurant" }, phoneNumber))),
        orderType === TSalesOrderType_1.TSalesOrderType.Pickup && (React.createElement("div", { className: css("section") },
            React.createElement("span", { className: css("directions") },
                React.createElement(IconButton_1.IconButton, { name: "change-location", size: standardSizes_1.TStandardSizes.Small, onClick: () => (0, openLink_1.openLink)(directionsLink) }),
                React.createElement("span", { className: css("directions_text") }, "directions"))))));
};
exports.RetailLocationInfo = RetailLocationInfo;
//# sourceMappingURL=index.js.map